var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOkxIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 225,
    viewBox: "0 0 225 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2632_1384",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 225,
    height: 225
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 112.5,
    cy: 112.5,
    r: 112.5,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2632_1384)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 225,
    height: 225,
    fill: "url(#pattern0_2632_1384)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2632_1384",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2632_1384",
    transform: "scale(0.00444444)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2632_1384",
    width: 225,
    height: 225,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAV1BMVEUAAAD///+MjIyJiYmdnZ2Xl5ewsLCzs7N2dnZycnK8vLxdXV2hoaFDQ0O1tbXq6upubm59fX1ISEje3t7n5+eEhIRaWloUFBSmpqYODg5BQUFbW1tpaWlssCYYAAABrklEQVR4nO3cy04CQRRFURoREATF9+v/v1MdaNRUwmmsbktda2xOaifMvOnJBAAAAAAAAAAAAADY43gx328x7bU5jTaPByr64qzLXPbYvAo3zwar+uA6fEzXnceby3jzesCyN6fxa/Lf6TTeHON3OotfcxRvKlRYl0KFJQoV1qVQYYlChXUpVFiiUGFdChWWKFRYl0KFJQoV1qVQYYlChXUp/P2F+f/xf2thfjdxE2+u4838vuMbVuFj5j02t+HmarCqTy6WJ/stN5PJ7d0qcXqbbl6ME5hLr6dGuXQaQn49tfvppx5oiOuptihU2D6FCtunUGH7FCpsn0KF7VOosH0KFbZPocL2KVTYPoUK26dQYfsUKmxffum0/umnHmoeBva5nhrD/Wy72G/7emO3WSceXv4y25yNUzjEd6Kaup46Ch/TdSfx5i7ezC86D/f370v//o2wQoUlChXWpVBhiUKFdSlUWKJQYV0KFZYoVFiXQoUlChXWpVBhiUKFdSlUWKJQYV3n8Wvy70Q9xptPA5a9+xffiQrsHnptbpLN9r4TBQAAAAAAAAAAAACteQaAmTY3J1TP+QAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkxIcon);
export default __webpack_public_path__ + "static/media/OKX-icon.e0336547d66fd1b7be7cac33f1969344.svg";
export { ForwardRef as ReactComponent };